import OSS from 'ali-oss';
import apis from '@/apis/common';

let ossConfig = null;

const upload = async (file,resetName) => {
  const res = await apis.ossConfig({
    bizCode: "yeahgo-user"
  });
  ossConfig = res?.data
  const client = new OSS({
    region: 'oss-cn-shenzhen',
    accessKeyId: ossConfig.accessKeyId,
    accessKeySecret: ossConfig.accessKeySecret,
    bucket: ossConfig.bucketName,
    stsToken: ossConfig.token
  });
  return new Promise((resolve) => {
    const fileName = `${'wechat/avatar'}/${+new Date()}-${resetName||file.name}`
    client.put(fileName, file).then(res => {
      resolve(res.url);
    }).catch(err => {
      console.log('上传失败：', err)
    })
  })
}

export default upload;
